module.exports = __webpack_public_path__ + "img/icons.48bba881.svg";